"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 16",
    ref: svgRef
  }, props), {}, {
    children: [(0, _jsxRuntime.jsx)("defs", {
      children: (0, _jsxRuntime.jsx)("path", {
        id: "prefix__a",
        d: "M12.8 9.067a.532.532 0 00-.533.533v2.133c0 .295-.24.534-.534.534H4.267a.535.535 0 01-.534-.534V9.6a.532.532 0 10-1.066 0v2.133a1.6 1.6 0 001.6 1.6h7.466a1.6 1.6 0 001.6-1.6V9.6a.532.532 0 00-.533-.533zm-5.179.912a.55.55 0 00.176.112c.13.057.277.057.406 0a.561.561 0 00.176-.112l2.133-2.134a.534.534 0 000-.757.534.534 0 00-.757 0L8.533 8.315V3.2a.532.532 0 10-1.066 0v5.115L6.245 7.088a.537.537 0 00-.896.241.533.533 0 00.139.516L7.621 9.98z"
      })
    }), (0, _jsxRuntime.jsxs)("g", {
      transform: "translate(.536)",
      fill: "currentColor",
      fillRule: "evenodd",
      children: [(0, _jsxRuntime.jsx)("mask", {
        id: "prefix__b",
        children: (0, _jsxRuntime.jsx)("use", {
          xlinkHref: "#prefix__a"
        })
      }), (0, _jsxRuntime.jsx)("use", {
        fillRule: "nonzero",
        xlinkHref: "#prefix__a"
      }), (0, _jsxRuntime.jsx)("path", {
        d: "M0 0h16v16H0z",
        mask: "url(#prefix__b)"
      })]
    })]
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Download.js.map